import { Link } from "react-router-dom";

export const SiteFooter = () => (
  <footer className="land-section pb-8 border-t-2 border-[var(--line)] mt-12 flex flex-wrap items-center justify-between gap-4" data-testid="site-footer">
    <p className="text-sm font-semibold text-[var(--muted)]">© {new Date().getFullYear()} DiamondPlay. Built for youth coaches.</p>
    <nav className="flex flex-wrap gap-4 font-bold text-sm">
      <Link to="/field" data-testid="footer-field-link">Field</Link>
      <Link to="/pricing" data-testid="footer-pricing-link">Pricing</Link>
      <Link to="/privacy" data-testid="footer-privacy-link">Privacy</Link>
      <Link to="/terms" data-testid="footer-terms-link">Terms</Link>
      <Link to="/contact" data-testid="footer-contact-link">Contact</Link>
    </nav>
  </footer>
);
